import React from "react";
import styled from "@emotion/styled";

const StyledLogo = styled.g`
  color: black;
`;

const Logo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 731.58 80.34">
      <StyledLogo fill="currentColor">
        <path
          className="cls-1"
          d="M3.92,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M18.32,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M25.51,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M32.71,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M51.72,8.34v8.35h-.88V9.22H47.11V8.34ZM50,10.1v6.59h-.87V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M61.5,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M75.9,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M97.49,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M104.69,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M116.5,8.34v8.35h-.88V9.22h-3.74V8.34Zm-1.76,1.76v6.59h-.87V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M133.48,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.67,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M147.87,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M155.07,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M166.89,8.34v8.35H166V9.22h-3.74V8.34Zm-1.76,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M176.66,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M183.86,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M191.06,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M198.26,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M212.65,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M219.85,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M227.05,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M238.86,8.34v8.35H238V9.22h-3.73V8.34ZM237.1,10.1v6.59h-.87V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M241.44,16.69v-14H248V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M260.46,8.34v8.35h-.88V9.22h-3.74V8.34ZM258.7,10.1v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M277.43,16.69v-14H284V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M296.44,8.34v8.35h-.88V9.22h-3.73V8.34Zm-1.75,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M327.81,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M346.83,8.34v8.35H346V9.22h-3.74V8.34Zm-1.76,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M349.41,16.69v-14H356V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M363.8,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M375.62,8.34v8.35h-.88V9.22H371V8.34Zm-1.76,1.76v6.59H373V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M418.8,8.34v8.35h-.88V9.22h-3.73V8.34Zm-1.75,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M450.17,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,16.69v-14H464V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M464.57,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,16.69v-14H500V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M505.17,8.34v8.35h-.87V9.22h-3.74V8.34Zm-1.75,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M507.76,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M522.15,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M529.35,16.69v-14H536V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M536.55,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M543.74,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M555.56,8.34v8.35h-.88V9.22h-3.74V8.34ZM553.8,10.1v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M579.73,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.93,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M594.13,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M601.33,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M613.14,8.34v8.35h-.88V9.22h-3.74V8.34Zm-1.76,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M630.12,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M637.31,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M644.51,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M651.71,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M658.91,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M666.1,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M677.92,8.34v8.35H677V9.22H673.3V8.34Zm-1.76,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M680.5,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M694.89,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,16.69v-14h6.6V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M716.49,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M723.69,16.69v-14h6.59V16.69Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M735.5,8.34v8.35h-.88V9.22h-3.74V8.34Zm-1.76,1.76v6.59h-.88V11h-2V10.1Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M3.92,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M24.91,22.74v.88H21.17v7.47H20.3V22.74ZM22.05,24.5h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M25.51,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M32.71,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M47.11,31.09V17H53.7V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M58.92,22.74v8.35H58V23.62H54.3v-.88ZM57.16,24.5v6.59h-.88V25.38h-2V24.5Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M61.5,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M82.49,22.74v.88H78.76v7.47h-.88V22.74ZM79.63,24.5h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M97.49,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M104.69,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M111.88,25.38V24.5h3.74V17h.88v8.34Zm2.86-1.76h-2.86v-.88h2V17h.87Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M119.08,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.08,22.74v.88h-3.74v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.87Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.67,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M147.87,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M155.07,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M162.27,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M174.08,22.74v8.35h-.88V23.62h-3.73v-.88Zm-1.75,1.76v6.59h-.88V25.38h-2V24.5Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M178.64,25.38V17h.88V24.5h3.74v.88Zm1.76-1.76V17h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M183.86,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M191.06,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M198.26,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M219.25,22.74v.88h-3.74v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M219.85,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M227.05,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M234.25,25.38V24.5H238V17h.88v8.34Zm2.85-1.76h-2.85v-.88h2V17h.87Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M241.44,31.09V17H248V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M257.82,17h.88V31.09h-.88Zm1.76,14.05V17h.88V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M277.43,31.09V17H284V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M293.81,17h.88V31.09h-.88Zm1.75,14.05V17h.88V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M327.81,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M344.19,17h.88V31.09h-.88ZM346,31.09V17h.88V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M349.41,31.09V17H356V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M363.8,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M371,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M382.82,22.74v8.35h-.88V23.62H378.2v-.88Zm-1.76,1.76v6.59h-.88V25.38h-2V24.5Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M416.17,17h.88V31.09h-.88Zm1.75,14.05V17h.88V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M450.17,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,31.09V17H464V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.17,22.74v.88h-3.74v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,22.74h6.6v.88H479Zm0,1.76h6.6v.88H479Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,22.74H500v.88h-6.6Zm0,1.76H500v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M500.56,25.38V24.5h3.74V17h.87v8.34Zm2.86-1.76h-2.86v-.88h2V17h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M507.76,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M528.75,22.74v.88H525v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M529.35,22.74H536v.88h-6.6Zm0,1.76H536v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M536.55,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M543.74,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M550.94,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M562.76,22.74v8.35h-.88V23.62h-3.74v-.88ZM561,24.5v6.59h-.88V25.38h-2V24.5Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M565.34,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.33,22.74v.88h-3.74v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.93,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M594.13,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M601.33,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M608.52,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M620.34,22.74v8.35h-.88V23.62h-3.74v-.88Zm-1.76,1.76v6.59h-.88V25.38h-2V24.5Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M622.92,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M630.12,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M643.91,22.74v.88h-3.74v7.47h-.88V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M644.51,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M651.71,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M658.91,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M666.1,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M673.3,25.38V24.5H677V17h.88v8.34Zm2.86-1.76H673.3v-.88h2V17h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M680.5,31.09V17h6.6V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,31.09V17h6.59V31.09Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M701.49,22.74v.88h-3.74v7.47h-.87V22.74Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,22.74h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M716.49,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M723.69,22.74h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M730.88,25.38V24.5h3.74V17h.88v8.34Zm2.86-1.76h-2.86v-.88h2V17h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M3.92,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M20.3,31.44h.87V45.49H20.3Zm1.75,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M47.11,45.49v-14H53.7V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M56.28,31.44h.88V45.49h-.88ZM58,45.49v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M61.5,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M75.9,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M102.11,37.14v8.35h-.88V38H97.49v-.88Zm-1.76,1.76v6.59h-.88V39.78h-2V38.9Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M119.08,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M133.48,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.67,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M147.87,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M155.07,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M162.27,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M171.45,31.44h.88V45.49h-.88Zm1.75,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M198.26,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M214.63,31.44h.88V45.49h-.88Zm1.76,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M241.44,45.49v-14H248V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M255.84,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M263,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M270.23,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M277.43,45.49v-14H284V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M293.81,31.44h.88V45.49h-.88Zm1.75,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M327.81,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M344.19,31.44h.88V45.49h-.88ZM346,45.49v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M349.41,45.49v-14H356V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M370.4,37.14V38h-3.74v7.47h-.88V37.14Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M371,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M378.2,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M390,37.14v8.35h-.88V38H385.4v-.88Zm-1.76,1.76v6.59h-.87V39.78h-2V38.9Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M416.17,31.44h.88V45.49h-.88Zm1.75,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M450.17,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,45.49v-14H464V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M464.57,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,45.49v-14H500V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M505.17,37.14v8.35h-.87V38h-3.74v-.88Zm-1.75,1.76v6.59h-.88V39.78h-2V38.9Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M507.76,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M522.15,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M529.35,45.49v-14H536V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M536.55,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M543.74,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M557.54,37.14V38H553.8v7.47h-.88V37.14Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M558.14,39.78V38.9h3.74V31.44h.88v8.34ZM561,38h-2.86v-.88h2v-5.7H561Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M565.34,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M579.73,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.93,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M594.13,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M601.33,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M608.52,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M617.7,31.44h.88V45.49h-.88Zm1.76,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M622.92,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M630.12,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M639.29,31.44h.88V45.49h-.88Zm1.76,14.05v-14h.88V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M680.5,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,45.49v-14h6.59V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M694.89,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,45.49v-14h6.6V45.49Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M721.1,37.14v8.35h-.87V38h-3.74v-.88Zm-1.75,1.76v6.59h-.88V39.78h-2V38.9Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M3.92,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M20.3,45.84h.87v14H20.3Zm1.75,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M47.11,59.89v-14H53.7v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M56.28,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M61.5,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M82.49,51.54v.88H78.76v7.47h-.88V51.54ZM79.63,53.3h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M97.49,54.18V53.3h3.74V45.84h.88v8.34Zm2.86-1.76H97.49v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M119.08,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.08,51.54v.88h-3.74v7.47h-.88V51.54Zm-2.86,1.76h2.86v.88h-2v5.71h-.87Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M140.67,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M147.87,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M155.07,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M162.27,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M171.45,45.84h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M198.26,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M214.63,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M241.44,59.89v-14H248v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M262.44,51.54v.88H258.7v7.47h-.88V51.54Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M263,51.54h6.59v.88H263Zm0,1.76h6.59v.88H263Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M270.23,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M277.43,59.89v-14H284v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M293.81,45.84h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M327.81,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M344.19,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M349.41,59.89v-14H356v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M365.78,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M373,54.18V45.84h.88V53.3h3.74v.88Zm1.76-1.76V45.84h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M378.2,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M385.4,59.89v-14H392v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M397.21,51.54v8.35h-.88V52.42h-3.74v-.88Zm-1.76,1.76v6.59h-.88V54.18h-2V53.3Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M416.17,45.84h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M452.16,54.18V45.84H453V53.3h3.74v.88Zm1.75-1.76V45.84h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,51.54H464v.88h-6.6Zm0,1.76H464v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M464.57,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,51.54h6.6v.88H479Zm0,1.76h6.6v.88H479Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,59.89v-14H500v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M502.54,45.84h.88v14h-.88Zm1.76,14v-14h.87v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M507.76,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M528.75,51.54v.88H525v7.47h-.88V51.54Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M529.35,51.54H536v.88h-6.6Zm0,1.76H536v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M536.55,51.54h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M543.74,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M550.94,54.18V53.3h3.74V45.84h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M565.34,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.33,51.54v.88h-3.74v7.47h-.88V51.54Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M586.93,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M594.13,51.54h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M601.33,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M608.52,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M617.7,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M622.92,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M630.12,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M639.29,45.84h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M680.5,59.89v-14h6.6v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,59.89v-14h6.59v14Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M701.49,51.54v.88h-3.74v7.47h-.87V51.54Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,51.54h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M716.49,54.18V53.3h3.74V45.84h.87v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M3.92,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M18.32,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M25.51,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M32.71,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M53.7,65.94v.88H50v7.47h-.87V65.94ZM50.84,67.7H53.7v.88h-2v5.71h-.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M54.3,68.58V67.7H58V60.24h.88v8.34Zm2.86-1.76H54.3v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M61.5,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M75.9,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M97.49,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M104.69,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M116.5,65.94v8.35h-.88V66.82h-3.74v-.88Zm-1.76,1.76v6.59h-.87V68.58h-2V67.7Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M119.08,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M135.46,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.87V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M155.07,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M162.27,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M171.45,60.24h.88V74.29h-.88Zm1.75,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M198.26,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M214.63,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M241.44,74.29V60.24H248V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M257.82,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M277.43,74.29V60.24H284V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M293.81,60.24h.88V74.29h-.88Zm1.75,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M327.81,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M344.19,60.24h.88V74.29h-.88ZM346,74.29V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M349.41,74.29V60.24H356V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M365.78,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M380.18,68.58V60.24h.88V67.7h3.74v.88Zm1.76-1.76V60.24h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M385.4,74.29V60.24H392V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M392.59,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M416.17,60.24h.88V74.29h-.88Zm1.75,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M450.17,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,74.29V60.24H464V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M464.57,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,74.29V60.24H500V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M502.54,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.87V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M507.76,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M524.13,60.24H525V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M565.34,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M581.71,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M601.33,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M608.52,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M617.7,60.24h.88V74.29h-.88Zm1.76,14.05V60.24h.88V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M624.9,68.58V60.24h.88V67.7h3.74v.88Zm1.76-1.76V60.24h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M630.12,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M637.31,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M644.51,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M651.71,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M658.91,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M666.1,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M677.92,65.94v8.35H677V66.82H673.3v-.88Zm-1.76,1.76v6.59h-.88V68.58h-2V67.7Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M680.5,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M694.89,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,74.29V60.24h6.6V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M716.49,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M723.69,74.29V60.24h6.59V74.29Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M735.5,65.94v8.35h-.88V66.82h-3.74v-.88Zm-1.76,1.76v6.59h-.88V68.58h-2V67.7Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M5.9,83V74.64h.88V82.1h3.74V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M11.12,80.34h6.59v.88H11.12Zm0,1.76h6.59V83H11.12Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M18.32,80.34h6.59v.88H18.32Zm0,1.76h6.59V83H18.32Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M25.51,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M32.71,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M39.91,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M47.11,83V82.1h3.73V74.64h.88V83ZM50,81.22H47.11v-.88h2v-5.7H50Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M63.48,83V74.64h.88V82.1H68.1V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M68.7,80.34h6.6v.88H68.7Zm0,1.76h6.6V83H68.7Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M75.9,80.34h6.59v.88H75.9Zm0,1.76h6.59V83H75.9Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M83.09,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M90.29,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M97.49,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M104.69,80.34h6.59v.88h-6.59Zm0,1.76h6.59V83h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M111.88,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.87Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M121.06,83V74.64h.88V82.1h3.74V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M126.28,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M133.48,83V82.1h3.74V74.64h.87V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M157.05,83V74.64h.88V82.1h3.74V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M162.27,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M169.47,83V82.1h3.73V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M200.24,83V74.64h.88V82.1h3.73V83ZM202,81.22V74.64h.87v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M205.45,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M212.65,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M243.42,83V74.64h.88V82.1H248V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M248.64,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M255.84,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M279.41,83V74.64h.88V82.1H284V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M284.63,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M291.83,83V82.1h3.73V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M329.79,83V74.64h.88V82.1h3.74V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M335,80.34h6.6v.88H335Zm0,1.76h6.6V83H335Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M342.21,83V82.1H346V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M351.39,83V74.64h.88V82.1H356V83Zm1.76-1.76V74.64H354v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M356.6,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M363.8,83V82.1h3.74V74.64h.88V83Zm2.86-1.76H363.8v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M387.38,83V74.64h.87V82.1H392V83Zm1.75-1.76V74.64H390v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M392.59,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M399.79,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M407,80.34h6.6v.88H407Zm0,1.76h6.6V83H407Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M414.19,83V82.1h3.73V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M452.16,83V74.64H453V82.1h3.74V83Zm1.75-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M457.37,80.34H464v.88h-6.6Zm0,1.76H464V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M464.57,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M471.77,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M479,80.34h6.6v.88H479Zm0,1.76h6.6V83H479Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M486.16,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M493.36,80.34H500v.88h-6.6Zm0,1.76H500V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M500.56,83V82.1h3.74V74.64h.87V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M509.74,83V74.64h.88V82.1h3.73V83Zm1.75-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M515,80.34h6.6v.88H515Zm0,1.76h6.6V83H515Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M522.15,83V82.1h3.74V74.64h.88V83ZM525,81.22h-2.86v-.88h2v-5.7H525Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M567.32,83V74.64h.88V82.1h3.73V83Zm1.76-1.76V74.64H570v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M572.53,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M579.73,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M603.31,83V74.64h.87V82.1h3.74V83Zm1.75-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M608.52,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M615.72,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M632.1,83V74.64H633V82.1h3.74V83Zm1.75-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M637.31,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M644.51,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M651.71,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M658.91,80.34h6.59v.88h-6.59Zm0,1.76h6.59V83h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M666.1,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M673.3,83V82.1H677V74.64h.88V83Zm2.86-1.76H673.3v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M682.48,83V74.64h.88V82.1h3.74V83Zm1.76-1.76V74.64h.88v5.7h2v.88Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M687.7,80.34h6.59v.88H687.7Zm0,1.76h6.59V83H687.7Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M694.89,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M702.09,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M709.29,80.34h6.6v.88h-6.6Zm0,1.76h6.6V83h-6.6Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M716.49,80.34h6.59v.88h-6.59Zm0,1.76h6.59V83h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M723.69,80.34h6.59v.88h-6.59Zm0,1.76h6.59V83h-6.59Z"
          transform="translate(-3.92 -2.64)"
        />
        <path
          className="cls-1"
          d="M730.88,83V82.1h3.74V74.64h.88V83Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-3.92 -2.64)"
        />
      </StyledLogo>
    </svg>
  );
};

export default Logo;
